export const orderStatusConstants = {
    PENDING: 'PENDING',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED'
};